import React, { useState, useEffect, useMemo } from 'react';
import { FaChevronCircleRight, FaChevronCircleLeft } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSections, fetchGroups } from '../../../features/sections/sectionsAPI';
import { fetchStudents } from '../../../features/students/studentsAPI';
import { sendAttendanceData } from '../../../features/attendance/attendanceAPI';
import { updateSections } from '../../../features/sections/sectionSlice';
import { handleGroupSelection, handleMonthChange, handleNextSection, handlePrevSection,handleYearChange,handleDaySelection,handleStudentSelection} from '../../../features/attendance/attendanceUtils';
import StudentsList from './StudentsList';
import LoadingSpinner from '../../LoadingSpinner';


const Attendance = () => {
    const dispatch = useDispatch();
  const sections = useSelector((state) => state.sections.sections);
  const [arr, setArr] = useState([]);
  const [activeSectionIndex, setActiveSectionIndex] = useState(0);
  const [token, setToken] = useState('');
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);
  const [activeMonthIndex, setActiveMonthIndex] = useState(0);
  const [activeYearIndex, setActiveYearIndex] = useState(0);
  const [activeDayIndex, setActiveDayIndex] = useState(0);
  const [showStudentList, setShowStudentList] = useState(false);
  const [studentList, setStudentList] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const months = useMemo(
    () => [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ],
    []
  );

  const years = useMemo(
    () => Array.from({ length: 11 }, (_, index) => 2024 + index),
    []
  );
 
  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
      fetchAllGroups(storedToken); // Fetch groups when token is set
    }
  }, []);

  const fetchAllGroups = async (token) => {
    try {
      const allGroups = await fetchGroups(token);
      setGroups(allGroups);
      setActiveGroupIndex(0);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  };

  useEffect(() => {
    // Define fetchSectionsByGroup inside the useEffect hook
    const fetchSectionsByGroup = async (group) => {
        try {
            const allSections = await fetchSections();
            const filteredSections = allSections.filter((section) => section.group.toLowerCase() === group.toLowerCase());
            dispatch(updateSections(filteredSections));
            setActiveSectionIndex(0);
        } catch (error) {
            console.error('Error fetching sections:', error);
        }
    };

    if (groups.length > 0) {
        fetchSectionsByGroup(groups[activeGroupIndex]);
    }

   
}, [activeGroupIndex, groups,dispatch]); // Dependencies array without fetchSectionsByGroup


  const handleShowStudentList = async () => {
    try {
      const students = await fetchStudents(token);
      const studentsInSection = students.filter(student => student.section_id === sections[activeSectionIndex].id);
      setStudentList(studentsInSection);
      setShowStudentList(true);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  };
  const closeStudentList = () => {
    setShowStudentList(false);
};
  const handleSendAttendance = async () => {
    try {
      const selectedDate = `${activeDayIndex + 1}/${months[activeMonthIndex]}/${years[activeYearIndex]}`;
      await sendAttendanceData(token, sections, activeSectionIndex, selectedDate, arr);
      setShowStudentList(false);
    } catch (error) {
      console.error('Error sending attendance data:', error);
    }
  };

  const daysInMonth = new Date(years[activeYearIndex], activeMonthIndex + 1, 0).getDate();
  const daysArray = Array.from({ length: daysInMonth }, (_, index) => index + 1);
  const emptyPlaceholders = Array.from({ length: 35 - (Math.ceil(daysInMonth / 7) * 7) });
//   Loading until fetching data
  if(loading){
    return(

        <LoadingSpinner/>
    )
}
    return (
        <div className='p-3' style={{ overflowY: 'auto' }} >
            <h2 className="sections-title text-2xl font-bold mb-5 text-center">Attendance</h2>
    {/* Slider for groups */}
<div className="group-slider flex items-center justify-between lg:mx-10 mx-0 my-2">
    {/* Left arrow icon */}
    <FaChevronCircleLeft 
        className={`arrow-icon hover:text-gray-500 mx-4 text-gray-400 cursor-pointer`} 
        onClick={() => handleGroupSelection("prev",activeGroupIndex, setActiveGroupIndex,groups)} 
    />
    {/* Group names */}
    <div className="flex justify-between w-full">
        {/* Display the first group if it exists */}
        {activeGroupIndex > 0 ? (
            <h1
                className="group text-2xl font-bold inactive opacity-50 mx-3 cursor-pointer"
                onClick={() => handleGroupSelection("prev",activeGroupIndex, setActiveGroupIndex,groups)}
            >
                {groups[activeGroupIndex - 1]}
            </h1>
        ):
        <h1
                className="group text-2xl font-bold inactive opacity-50 mx-3 cursor-pointer"
                onClick={() => handleGroupSelection("prev",activeGroupIndex, setActiveGroupIndex,groups)}
            >
                {groups[ groups.length-1]}
            </h1>}
        {/* Display the active group */}
        <h1
            className="group text-2xl font-bold mx-3 active cursor-pointer"            
        >
            {groups[activeGroupIndex]}
        </h1>
        {/* Display the last group if it exists */}
        {activeGroupIndex < groups.length - 1 ?(
            <h1
                className="group text-2xl font-bold mx-3 inactive opacity-50 cursor-pointer"
                onClick={() => handleGroupSelection("prev",activeGroupIndex , setActiveGroupIndex,groups)}
            >
                {groups[activeGroupIndex + 1]}
            </h1>
        ):
        <h1
                className="group text-2xl font-bold mx-3 inactive opacity-50 cursor-pointer"
                onClick={() => handleGroupSelection("next",0, setActiveGroupIndex,groups)}
            >
                {groups[0]}
            </h1>
        }
    </div>
    {/* Right arrow icon */}
    <FaChevronCircleRight 
        className={`arrow-icon hover:text-gray-500 mx-4 text-gray-400 cursor-pointer  `} 
        onClick={() => handleGroupSelection("next",activeGroupIndex , setActiveGroupIndex,groups)} 
    />
</div>

    
            {/* Display the active section */}
            <div className="section-display flex justify-between ">
                {/* Left arrow for section slider */}
                <div className="navigation-arrows flex items-center">
                <FaChevronCircleLeft 
    className={`arrow-icon hover:text-gray-500 mx-4 text-gray-400  ${activeSectionIndex > 0 ? 'cursor-pointer' : "opacity-0"}`} 
    onClick={() => handlePrevSection(activeSectionIndex , setActiveSectionIndex)} 
/>

                </div>
                {sections.length > 0 && (
                    <div className="active-section w-1/2 m-2">
                        {/* Render section information */}
                        <h1 className="group-title text-lg font-semibold mb-2">{sections[activeSectionIndex].name}</h1>
                        <div
                            className="section-card bg-white p-4 rounded-md shadow-md mb-2 border-l-4"
                            style={{ borderColor: `${sections[activeSectionIndex].color}` }}
                        >
                            <h4 className="section-day text-base font-medium mb-1">{sections[activeSectionIndex].days}</h4>
                            <p className="section-time text-sm">{sections[activeSectionIndex].time_period}</p>
                        </div>
                    </div>
                )}
                {/* Right arrow for section slider */}
                <div className='flex items-center'>
                    <FaChevronCircleRight  
                        className={`arrow-icon hover:text-gray-500 mx-4 text-gray-400  ${activeSectionIndex < sections.length-1 ? 'cursor-pointer' :"opacity-0"}`} 
                        onClick={() =>handleNextSection(activeSectionIndex, sections, setActiveSectionIndex)} 
                    />
                </div>
            </div>
    
            {/* Slider for months */}
            <div className="month-slider flex justify-between m-4 w-25">
                <FaChevronCircleLeft 
                    className="arrow-icon hover:text-gray-500 mx-4 text-gray-400 cursor-pointer" 
                    onClick={() => handleMonthChange('prev',activeMonthIndex, setActiveMonthIndex, months)} 
                />
                <h2 className="active-month">{months[activeMonthIndex]}</h2>
                <FaChevronCircleRight 
                    className="arrow-icon hover:text-gray-500 mx-4 text-gray-400 cursor-pointer" 
                    onClick={() => handleMonthChange('next',activeMonthIndex, setActiveMonthIndex, months)} 
                />
            </div>
    
            {/* Slider for years */}
            <div className="year-slider flex justify-between m-4 w-25">
                <FaChevronCircleLeft 
                    className="arrow-icon hover:text-gray-500 mx-4 text-gray-400 cursor-pointer" 
                    onClick={() => handleYearChange('prev', activeYearIndex, setActiveYearIndex, years)} 
                />
                <h2 className="active-year">{years[activeYearIndex]}</h2>
                <FaChevronCircleRight 
                    className="arrow-icon hover:text-gray-500 mx-4 text-gray-400 cursor-pointer" 
                    onClick={() => handleYearChange('next', activeYearIndex, setActiveYearIndex, years)} 
                />
            </div>
    
           {/* Days selection */}
           <div className="flex justify-center items-center h-full mt-4">
           <div className="day-selection flex flex-wrap justify-center lg:w-1/2 lg:p-2 md:mx-6">
    {daysArray.map((day, index) => (
        <div
            key={index}
            className={`cursor-pointer justify-center flex items-center mb-2 ${index === activeDayIndex ? 'bg-gray-300' : ''}`}
            style={{"width":"13%"}}
            onClick={() => handleDaySelection(index,setActiveDayIndex)}
        >
            {day}
        </div>
    ))}
    {/* Render empty placeholders to complete the last row */}
    {emptyPlaceholders.map((_, index) => (
        <div key={index} className="day-placeholder"></div>
    ))}
</div>

    </div>
            <div className='flex justify-center mt-5'>
                <button
                    type="button"
                    className="bg-gray-300 hover:bg-gray-400 text-bold px-9 py-2 rounded-full focus:outline-none cursor-pointer"
                    onClick={handleShowStudentList}
                >
                    Next
                </button>
            </div>
    {/* Students list */}
    {showStudentList && (
                <StudentsList
                    studentList={studentList}
                    handleStudentSelection={handleStudentSelection}
                    handleSendAttendance={handleSendAttendance}
                    closeStudentList={closeStudentList}
                    arr={arr}
                    setArr={setArr}
                    activeDayIndex={activeDayIndex}
                    activeMonthIndex={activeMonthIndex}
                    activeYearIndex={activeYearIndex}
                    years={years}
                    months={months}
                />
            )}
        </div>

  
    );
};

export default Attendance;
